module.exports = a => !!a && a.constructor === Object
